import {Cureus} from '../Cureus';

Cureus.History = {};

//= require_tree ./History